
<div class="site">
    <app-header *ngIf="!isMobile"></app-header>
    <app-header-mobile *ngIf="isMobile"></app-header-mobile>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
</div>

<ngx-loading [show]="global.loading"></ngx-loading>
<a id="back-to-top" *ngIf="isShow" (click)="gotoTop()">
    <fa-icon [icon]="faChevronUp" [styles]="{ height: '60px', width: '50px', color: '#fff'}"></fa-icon>
</a>